module.exports = __webpack_public_path__ + "img/HappyPhoto7.2ebac182.jpeg";